import Button from './Button';
import CustomSelect from './CustomSelect';

function SearchFilterBar({
  clearLabel = 'Clear',
  onClear,
  onSearchChange,
  onStatusChange,
  searchPlaceholder = 'Search...',
  searchValue,
  statusValue,
}) {
  return (
    <div className="rounded-3xl border border-[#ddcfc2] bg-[#fcfbf9] p-2.5">
      <div className="grid gap-2.5 lg:grid-cols-[1fr_180px_auto] lg:items-center">
        <label className="block">
          <span className="sr-only">Search</span>
          <input
            className="w-full rounded-2xl border border-[#d7c8ba] bg-white px-4 py-2.5 text-sm text-[#111111] outline-none placeholder:text-[#a1968d] focus:border-[#8e7663] focus:shadow-[0_0_0_4px_rgba(142,118,99,0.10)]"
            onChange={(event) => onSearchChange(event.target.value)}
            placeholder={searchPlaceholder}
            type="search"
            value={searchValue}
          />
        </label>

        <CustomSelect
          name="status"
          value={statusValue}
          onChange={(event) => onStatusChange(event.target.value)}
          options={[
            { value: 'all', label: 'All status' },
            { value: 'active', label: 'Active' },
            { value: 'inactive', label: 'Inactive' },
          ]}
          searchable={false}
        />

        <Button
          className="w-full justify-center px-3 py-2 text-sm lg:w-auto"
          onClick={onClear}
          type="button"
          variant="secondary"
        >
          {clearLabel}
        </Button>
      </div>
    </div>
  );
}

export default SearchFilterBar;
